import React, { useContext } from 'react'
import MessageBanner from 'components/Luxkit/Banners/MessageBanner'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import Group from 'components/utils/Group'
import BodyText from 'components/Luxkit/Typography/BodyText'
import SolidFireIcon from 'components/Luxkit/Icons/solid/SolidFireIcon'
import Image from 'components/Common/Image/Image'
import FormatCurrency from '../FormatCurrency'
import ContactContext from 'contexts/contactContext'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

interface Props {
  carrierLogo?: string;
  carrierName: string;
  destinationName: string;
  price: number;
  onCheckAvailability: () => void;
}

function UpsellBanner(props: Props) {
  const {
    carrierLogo,
    carrierName,
    destinationName,
    price,
    onCheckAvailability,
  } = props

  const geoContact = useContext(ContactContext)

  return (
    <MessageBanner
      description={
        <Group direction="horizontal" verticalAlign="center" gap="0 12">
          {carrierLogo && (
            <CSSBreakpoint min="tablet">
              <Image
                width={100}
                image={{ url: carrierLogo, title: carrierName }}
              />
            </CSSBreakpoint>
          )}

          <Group direction="vertical" gap={4}>
            <BodyTextBlock variant="medium" weight="bold">
              <BodyText variant="medium" colour="urgency" as="span">
                <SolidFireIcon /> Limited time flight offer
              </BodyText>{' '}
              Return flights to {destinationName} from
              {' '}<FormatCurrency value={price} format="roundedDollar" />*/{' '}
              person with {carrierName}.
            </BodyTextBlock>
          </Group>
        </Group>
      }
      primaryActionButtonProps={{
        children: 'Check availability',
        onClick: onCheckAvailability,
      }}
      secondaryActionButtonProps={{
        children: geoContact.defaultContact.humanReadable,
        href: `tel:${geoContact.defaultContact.number}`,
        startIcon: <LinePhoneIcon />,
      }}
      kind="promotional-primary"
    />
  )
}

export default UpsellBanner
